import { TFunction } from "i18next";
import { object, string } from "yup";

export const supportSchema = (t: TFunction) =>
  object({
    subject: string().required(t("support.requiredSubject")),
    message: string()
      .required(t("support.messageRequired"))
      .min(50, t("support.shortMessage"))
      .max(5000, t("support.longMessage")),
  });
